<template>
  <div class="loading--overlay" v-bind:class="{ active: loading }">
    <div class="ui orange progress inverted progressbar" v-if="percentual > 0 && percentual < 100">
      <div class="bar" :style="styleProgress">
        <div class="progress">{{ percentual }}%</div>
      </div>
      <div class="label" v-if="texto && texto != ''">{{ texto }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Loading',
  computed: {
    ...mapState('global', {
      loading: state => state.loading,
      percentual: state => state.percentual,
      texto: state => state.textoLoading,
    }),
    styleProgress() {
      return `transition-duration: 300ms; width: ${this.percentual}%`;
    },
  },
};
</script>

<style lang="scss">
  .loading--overlay {
    position: fixed;
    display: none;
  }
  .loading--overlay.active {
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0,0,0, 0.9);
    z-index: 9999;
    background: black url('https://sistema.otimogestor.com.br/loading.gif') center no-repeat;
    background-size: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    filter: alpha(opacity=90); /* internet explorer */
    -khtml-opacity: 0.90;      /* khtml, old safari */
    -moz-opacity: 0.90;       /* mozilla, netscape */
    opacity: 0.90;           /* fx, safari, opera */
  }
  .progressbar {
    margin-top: 20% !important;
    width: 80%;
  }
</style>
